<template>
  <div class="todo">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'todo',
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// Todo.vue?70fc6e9e